export enum BinType {
  GENERIC = "Generic",
  FEEDER = "Feeder",
  TRAY = "Tray",
  JOB_TOTE = "Job tote",
}

export enum FeederWidthMM {
  EIGHT_MM = 8,
  TWELVE_MM = 12,
  SIXTEEN_MM = 16,
  TWENTY_FOUR_MM = 24,
  THIRTY_TWO_MM = 32,
  FORTY_FOUR_MM = 44,
}

export interface FeederDetails {
  width_mm: FeederWidthMM;
}

export interface TrayDetails {
  num_columns: number;
  num_rows: number;
  slot_depth_mm: number;
  slot_width_mm: number;
  slot_height_mm: number;
}

export interface InventoryBin {
  flashpcb_bin_barcode: string;
  bin_location: string;
  bin_name: string;
  board_id: string | null;
  bin_type: BinType;
  feeder_details: FeederDetails | null;
  tray_details: TrayDetails | null;
  can_allocate_from_this_bin: boolean;
}

export const DEFAULT_EMPTY_BIN: InventoryBin = {
  flashpcb_bin_barcode: "",
  bin_location: "",
  bin_name: "",
  board_id: null,
  bin_type: BinType.GENERIC,
  feeder_details: null,
  tray_details: null,
  can_allocate_from_this_bin: true,
};
